import type { TOC } from '@ember/component/template-only';

import GenieSharedChatComponent from 'webapp/components/genie/shared-chat/index';
import type { SharedChatModel } from 'webapp/routes/shared-chat';

interface Args {
	model: SharedChatModel;
}

const SharedChatRouteTemplate: TOC<Args> = <template>
	<GenieSharedChatComponent @shareToken={{@model.shareToken}} />
</template>;

export default SharedChatRouteTemplate;
